import { Component } from '@angular/core';

// extends
import { SetPasswordPage } from "../../../set-password/set-password.page";

@Component({
    selector: 'app-set-password',
    templateUrl: './set-password.page.html',
    styleUrls: ['./set-password.page.scss'],
})
export class CustomSetPasswordPage extends SetPasswordPage {
    /**
     * if we should show sidebar
     *
     * @type {boolean}
     */
    public hideSidebar: boolean = true;

    public initSetting() {

        // follow invitation - token must be added to every possible request from here
        const external_secret = this.route.snapshot.queryParams['uid'];
        if (!!external_secret) {
            this.showLoading();
            this.participantService.getByInvitationExternalSecret(external_secret).subscribe(
                (participant: any) => {
                    this.hideLoading();
                    setTimeout(() => {
                        this.hideLoading();
                    }, 1000);
                    setTimeout(() => {
                        this.hideLoading();
                    }, 5000);

                    if (participant.email) {
                        this.model.external_type = 'sklm';
                        this.model.external_secret = external_secret;
                        this.model.email = participant.email;
                        this.storage.set('external_secret', external_secret);
                    } else {
                        // invitation token is not valid
                        this.showError(this.translate.instant('ERROR_INVALID_EXTERNAL_SECRET'));
                        this.router.navigate(['/login']);
                    }
                }, (error) => {
                    this.hideLoading();
                    setTimeout(() => {
                        this.hideLoading();
                    }, 1000);
                    setTimeout(() => {
                        this.hideLoading();
                    }, 5000);
                });
        } else {
            this.storage.get('external_secret').then((external_secret) => {
                if (!!external_secret) {
                    this.showLoading();
                    this.participantService.getByInvitationExternalSecret(external_secret).subscribe(
                        (participant: any) => {
                            this.hideLoading();
                            setTimeout(() => {
                                this.hideLoading();
                            }, 1000);
                            setTimeout(() => {
                                this.hideLoading();
                            }, 5000);
                            if (participant.email) {
                                this.model.external_type = 'sklm';
                                this.model.external_secret = external_secret;
                                this.model.email = participant.email;
                            } else {
                                // invitation token is not valid
                                this.storage.remove('external_secret');
                                this.showError(this.translate.instant('ERROR_INVALID_EXTERNAL_SECRET'));
                                this.router.navigate(['/login']);
                            }
                        }, (error) => {
                            this.hideLoading();
                            setTimeout(() => {
                                this.hideLoading();
                            }, 1000);
                            setTimeout(() => {
                                this.hideLoading();
                            }, 5000);
                        });
                }
            });
        }
    }
}
